import _Set from "@babel/runtime-corejs2/core-js/set";
import _toConsumableArray from "@babel/runtime-corejs2/helpers/esm/toConsumableArray";
import React from 'react';
import Form from 'antd/lib/form';
import WrapIfAdditional from './WrapIfAdditional';
var VERTICAL_LABEL_COL = {
  span: 24
};
var VERTICAL_WRAPPER_COL = {
  span: 24
};
var FieldTemplate = function FieldTemplate(_ref) {
  var children = _ref.children,
    classNames = _ref.classNames,
    description = _ref.description,
    disabled = _ref.disabled,
    displayLabel = _ref.displayLabel,
    formContext = _ref.formContext,
    help = _ref.help,
    hidden = _ref.hidden,
    id = _ref.id,
    label = _ref.label,
    onDropPropertyClick = _ref.onDropPropertyClick,
    onKeyChange = _ref.onKeyChange,
    rawDescription = _ref.rawDescription,
    rawErrors = _ref.rawErrors,
    rawHelp = _ref.rawHelp,
    readonly = _ref.readonly,
    required = _ref.required,
    schema = _ref.schema;
  var colon = formContext.colon,
    _formContext$labelCol = formContext.labelCol,
    labelCol = _formContext$labelCol === void 0 ? VERTICAL_LABEL_COL : _formContext$labelCol,
    _formContext$wrapperC = formContext.wrapperCol,
    wrapperCol = _formContext$wrapperC === void 0 ? VERTICAL_WRAPPER_COL : _formContext$wrapperC,
    wrapperStyle = formContext.wrapperStyle;
  if (hidden) {
    return /*#__PURE__*/React.createElement("div", {
      className: "field-hidden"
    }, children);
  }
  var renderFieldErrors = function renderFieldErrors() {
    return _toConsumableArray(new _Set(rawErrors)).map(function (error) {
      return /*#__PURE__*/React.createElement("div", {
        key: "field-".concat(id, "-error-").concat(error)
      }, error);
    });
  };
  return /*#__PURE__*/React.createElement(WrapIfAdditional, {
    classNames: classNames,
    disabled: disabled,
    formContext: formContext,
    id: id,
    label: label,
    onDropPropertyClick: onDropPropertyClick,
    onKeyChange: onKeyChange,
    readonly: readonly,
    required: required,
    schema: schema
  }, id === 'root' ? children : /*#__PURE__*/React.createElement(Form.Item, {
    colon: colon // extra={!!rawDescription && description}
    ,

    hasFeedback: schema.type !== 'array' && schema.type !== 'object',
    help: !!rawHelp && help || !!rawErrors && renderFieldErrors(),
    htmlFor: id,
    label: displayLabel && label,
    labelCol: labelCol,
    required: required,
    style: wrapperStyle,
    validateStatus: rawErrors ? 'error' : undefined,
    wrapperCol: wrapperCol
  }, children));
};
export default FieldTemplate;